import {
  AccountTypeDto,
  CustomerTypeDto,
  Dtos_V2_Customer_CustomerDto,
  EmployeeDto,
  PricingSchemeDto,
  SalesRegionDto,
  TermDto
} from '@/common/infrastructure/gql/generated/schema';

export enum ContactInfoType {
  EMAIL = 'E-mail',
  PHONE = 'Phone',
  LANDLINE = 'Landline',
  FAX = 'Fax',
  MOBILE = 'Mobile',
  OTHER = 'Other'
}

// Shared constants for contact types
export const ALLOWED_CALLER_ID_TYPES = [ContactInfoType.MOBILE, ContactInfoType.LANDLINE, ContactInfoType.PHONE, ContactInfoType.EMAIL];
export const ALLOWED_CALLER_ID_TYPES_SET = new Set(ALLOWED_CALLER_ID_TYPES);

export type CustomerTableData = {
  id: number;
  companyName: string;
  primaryEmail: string;
  primaryPhone: string;
  address: {
    address: string;
  };
  salesRegion: string;
  salesAgent: string;
  customerType: string;
  maxCredit: number;
  customerStatus: string;
  deletable: boolean;
  financialSummary?: {
    revenue: number;
  };
};

export type CustomerFormData = {
  id?: number;

  // First section
  companyName?: string;
  primaryEmail?: string;
  primaryPhone?: string;
  customerTypeId?: number | null;
  salesAgentId?: number | null;
  termId?: number | null;
  pricingSchemeId?: number | null;
  salesRegionId?: number | null;
  accountTypeId?: number | null;
  customerDiscount?: number;
  maxCredit?: number;
  taxNumber?: string;

  // Second section
  address?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  country?: string;
  latitude?: number;
  longitude?: number;

  // Third section
  contacts?: {
    id?: number;
    firstName?: string;
    lastName?: string;
    title?: string;
    email?: string;
    phone?: string;
    contactInformation?: {
      id?: number;
      type: ContactInfoType;
      contact: string;
    }[];
  }[];

  // Fourth section
  notes?: string;
};

export type CustomerFormOptions = {
  availableCustomerTypes: CustomerTypeDto[];
  availableSalesAgents: EmployeeDto[];
  availableTerms: TermDto[];
  availablePricingSchemes: PricingSchemeDto[];
  availableSalesRegions: SalesRegionDto[];
  availableAccountTypes?: AccountTypeDto[];
};

export type CustomerDetails = Dtos_V2_Customer_CustomerDto & {
  deletable: boolean;
  availableCustomerTypes: CustomerTypeDto[];
  availableSalesAgents: EmployeeDto[];
  availableTerms: TermDto[];
  availablePricingSchemes: PricingSchemeDto[];
  availableSalesRegions: SalesRegionDto[];
  availableAccountTypes: AccountTypeDto[];
};
